// ════════════════════════════════════════════════════════════════════════════
//  Udisys Gestor Web — components/ServicoSearchCombobox.tsx
//
//  Escolhe um serviço do cadastro (cad_servico) por código ou descrição, sem
//  pedir o ID. `onSelect` devolve valor/comissão para autopreencher a linha.
//  API: GET /api/servicos/lookup?busca=  e  GET /api/servicos/{id}.
// ════════════════════════════════════════════════════════════════════════════

import { EntityCombobox } from "@/components/EntityCombobox";
import { apiClient } from "@/lib/apiClient";

const BASE = "/api/servicos";

export interface ServicoLookup {
  id: number;
  codigo: string | null;
  descricao: string;
  extra?: string | null;
  valor: number;
  comissaoPercentual: number;
  aliquotaIss: number;
  itemListaServico?: string | null;
  isInativo: boolean;
}

async function buscarServicos(busca: string): Promise<ServicoLookup[]> {
  const { data } = await apiClient.get<ServicoLookup[]>(`${BASE}/lookup`, {
    params: { busca: busca || undefined, limite: 30 },
  });
  return data;
}

async function obterServico(id: number): Promise<ServicoLookup> {
  const { data } = await apiClient.get<ServicoLookup>(`${BASE}/${id}`);
  return data;
}

interface ServicoSearchComboboxProps {
  value?: number | null;
  onChange?: (id: number | null) => void;
  onSelect?: (servico: ServicoLookup | null) => void;
  /** Descrição já conhecida (DTO em edição): exibe sem GET. */
  descricaoInicial?: string | null;
  placeholder?: string;
  disabled?: boolean;
  className?: string;
}

export function ServicoSearchCombobox({
  descricaoInicial, placeholder = "Selecione o serviço...", ...props
}: ServicoSearchComboboxProps) {
  const itemInicial = props.value && descricaoInicial
    ? {
        id: props.value, codigo: String(props.value), descricao: descricaoInicial,
        valor: 0, comissaoPercentual: 0, aliquotaIss: 0, isInativo: false,
      }
    : null;
  return (
    <EntityCombobox<ServicoLookup>
      {...props}
      itemInicial={itemInicial}
      queryKey="servico-lookup"
      buscar={buscarServicos}
      obterPorId={obterServico}
      getId={(s) => s.id}
      getCodigo={(s) => s.codigo}
      getDescricao={(s) => s.descricao}
      getExtra={(s) => s.extra}
      placeholder={placeholder}
      placeholderBusca="Buscar por código ou descrição..."
    />
  );
}
